import { render } from "./PdfMgtSummaryTemplate.vue?vue&type=template&id=04153c8a&scoped=true&ts=true"
import script from "./PdfMgtSummaryTemplate.vue?vue&type=script&lang=ts"
export * from "./PdfMgtSummaryTemplate.vue?vue&type=script&lang=ts"

import "./PdfMgtSummaryTemplate.vue?vue&type=style&index=0&id=04153c8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04153c8a"]])

export default __exports__